import AdminUserCreatePage from "@/features/system-settings/pages/AdminUserCreate";

const AdminUserCreate = () => {
  return <AdminUserCreatePage />;
};
export default AdminUserCreate;
